import { ChangeDetectorRef, EventEmitter, } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { ClrType, InputType, } from '@components/shared/ui-parameter-collection/clr-type.definitions';
import cloneDeep from 'lodash-es/cloneDeep';
export var ParameterValidators;
(function (ParameterValidators) {
    ParameterValidators.required = function (parameterMap) {
        return function (c) {
            var isRequirementSatisfied = (parameterMap || [])
                .every(function (field) {
                if (!field.required) {
                    return true;
                }
                var hasSource = field.source != null;
                var hasValue = !!c.value &&
                    c.value[field.name] != null &&
                    c.value[field.name] !== '';
                return hasSource ||
                    hasValue;
            });
            return isRequirementSatisfied ?
                null : {
                required: true,
            };
        };
    };
})(ParameterValidators || (ParameterValidators = {}));
var UiParameterCollectionComponent = /** @class */ (function () {
    function UiParameterCollectionComponent(fb, _cd) {
        this._cd = _cd;
        this.InputType = InputType;
        this.editable = false;
        this.closed = new EventEmitter();
        this.inputDefinition = null;
        this.value = null;
        this.expandedRow = null;
        this._data = [];
        this.onChange = function () { };
        this.onTouch = function () { };
        this.formGroup = fb.group({});
    }
    Object.defineProperty(UiParameterCollectionComponent.prototype, "collection", {
        get: function () {
            return this._data.slice(0);
        },
        set: function (value) {
            var clone = cloneDeep(value) || [];
            clone.forEach(function (argument, idx) {
                argument.clrType = ClrType.parseType(argument.type);
                argument.id = idx;
            });
            this._data = clone;
            this.expandedRow = null;
            this._updateRowValues();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiParameterCollectionComponent.prototype, "isOpen", {
        get: function () {
            return !!this.expandedRow;
        },
        enumerable: true,
        configurable: true
    });
    UiParameterCollectionComponent.prototype.writeValue = function (value) {
        if (typeof value === 'object') {
            this.value = value;
        }
        else if (typeof value === 'string') {
            try {
                this.value = JSON.parse(value);
            }
            catch (_a) {
                this.value = null;
            }
        }
        else {
            this.value = null;
        }
        this._updateRowValues();
        this._cd.markForCheck();
    };
    UiParameterCollectionComponent.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function () {
            _this.value = {};
            _this._data
                .forEach(function (argument) {
                _this.value[argument.name] = argument.value;
            });
            fn(_this.value);
        };
    };
    UiParameterCollectionComponent.prototype.registerOnTouched = function (fn) {
        this.onTouch = fn;
    };
    UiParameterCollectionComponent.prototype.editEntry = function (argument) {
        var _this = this;
        Object.keys(this.formGroup.controls)
            .forEach(function (key) { return _this.close({
            name: key,
        }); });
        this._setFormGroup(argument);
        this.expandedRow = argument;
    };
    UiParameterCollectionComponent.prototype.close = function (argument) {
        this.formGroup.removeControl(argument.name);
        this.expandedRow = null;
        this.inputDefinition = null;
        this.onTouch();
        this.closed.emit();
    };
    UiParameterCollectionComponent.prototype.save = function (argument) {
        if (this.formGroup.invalid) {
            return;
        }
        var value = this.formGroup.value[argument.name];
        this.value[argument.name] = value === '' ?
            null :
            this._reverseMap(this.inputDefinition.type, value);
        this._updateRowValues();
        this.close(argument);
        this.onChange();
    };
    UiParameterCollectionComponent.prototype.clear = function (argument) {
        delete this.value[argument.name];
        this._updateRowValues();
        this.onChange();
    };
    UiParameterCollectionComponent.prototype._setFormGroup = function (argument) {
        var validators = [];
        if (argument.required) {
            validators.push(Validators.required);
        }
        this.inputDefinition = ClrType.inputConfiguration(argument.type);
        validators.push(this.inputDefinition.validator);
        var formControl = new FormControl(this._valueForType(this.inputDefinition.type, argument.value), validators);
        this.formGroup.addControl(argument.name, formControl);
    };
    UiParameterCollectionComponent.prototype._valueForType = function (type, value) {
        switch (type) {
            case InputType.Boolean:
                if (typeof value === 'string') {
                    return value.toLowerCase() === 'true' ?
                        true :
                        value.toLowerCase() === 'false' ?
                            false :
                            null;
                }
                return value;
            case InputType.Complex:
                return JSON.stringify(value, null, 4);
            default:
                return value;
        }
    };
    UiParameterCollectionComponent.prototype._reverseMap = function (type, value) {
        switch (type) {
            case InputType.Complex:
                return JSON.parse(value);
            case InputType.Number:
                return Number(value);
            default:
                return value;
        }
    };
    UiParameterCollectionComponent.prototype._updateRowValues = function () {
        var _this = this;
        if (this._data instanceof Array &&
            this.value instanceof Object) {
            this._data.forEach(function (argument) {
                argument.value = _this.value[argument.name];
            });
        }
    };
    return UiParameterCollectionComponent;
}());
export { UiParameterCollectionComponent };
